import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#efe1cd] px-6">
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="w-full max-w-md bg-[#fbf6ec] rounded-2xl p-9 border border-[#e3b4b0]/50 shadow-[0_18px_50px_rgba(156,85,96,0.15)]"
      >
        <Link to="/" className="font-display text-2xl text-[#9c5560] block text-center mb-1">
          Rosefield<span className="text-[#c2a04b]"> Harmonic</span>
        </Link>
        <p className="text-center font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-7">Sanctuary Admin</p>

        {error && (
          <p data-testid="login-error" className="mb-4 text-sm text-red-700 bg-red-100 rounded-lg px-4 py-2">{error}</p>
        )}

        <label className="font-accent text-sm text-[#3a2630]/80">Email</label>
        <input
          data-testid="login-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-2 mb-4 w-full rounded-xl border border-[#e3b4b0]/60 bg-[#f7efe2] px-4 py-3 outline-none focus:border-[#b76e79]"
        />
        <label className="font-accent text-sm text-[#3a2630]/80">Password</label>
        <input
          data-testid="login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 mb-6 w-full rounded-xl border border-[#e3b4b0]/60 bg-[#f7efe2] px-4 py-3 outline-none focus:border-[#b76e79]"
        />
        <button
          data-testid="login-submit"
          disabled={busy}
          className="w-full font-accent tracking-wide px-8 py-3.5 rounded-full bg-[#b76e79] text-[#f7efe2] hover:bg-[#9c5560] transition-colors disabled:opacity-60"
        >
          {busy ? "Entering…" : "Enter"}
        </button>
      </form>
    </div>
  );
}
